import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material/styles";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { PieChart, PieSeries } from "@mui/x-charts";
import { List, ListItem, ListItemText, Stack } from "@mui/material";
import IndiaMap from "./Maps";
import { useEffect } from "react";
import axios from "axios";
import MapChart from "./Maps";

function Summary() {
	const theme = useTheme();
	const [summaryData, setSummaryData] = useState({});
	const [storeTypeCount, setStoreTypeCount] = useState([]);
	const [storeBrandCount, setStoreBrandCount] = useState([]);
	const [storeGradeCount, setStoreGradeCount] = useState([]);
	const [storeRegionCount, setStoreRegionCount] = useState([]);
	const [eboStoreCount, setEboStoreCount] = useState(100);

	useEffect(() => {
		const fetchSummaryData = async () => {
			try {
				const response = await axios.get("/api/ebo_store_v4/summary"); // update this path if needed
				setSummaryData(response.data);
				setStoreTypeCount(response.data?.store_type_count || []);
				setStoreBrandCount(response.data?.store_brand_count || []);
				setStoreRegionCount(response.data?.store_region_count || []);
				setStoreGradeCount(response.data?.store_grade_count || []);
			} catch (err) {
				// setError(err);
				console.error("Error fetching summary:", err);
			} finally {
				// setLoading(false);
			}
		};

		fetchSummaryData();
	}, []);

	return (
		<Box>
			<Card sx={{ display: "flex" }}>
				<Box sx={{ display: "flex", flexDirection: "column" }}>
					<CardContent sx={{ flex: "1 0 auto" }}>
						<Typography component="div" variant="h5">
							Total Stores : {summaryData?.store_count}
						</Typography>
						<Typography variant="subtitle1" component="div" sx={{ color: "text.secondary" }}>
							(EBO)
						</Typography>
					</CardContent>
					<Stack
						display={"flex"}
						flexDirection={"row"}
						justifyContent={"space-between"}
						alignContent={"center"}
						sx={{ pl: 1, pb: 1, pt: 2 }}>
						<Box>
							<PieChart
								series={[
									{
										data: storeTypeCount,
										highlightScope: { fade: "global", highlight: "item" },
										faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
										innerRadius: 40,
										outerRadius: 90,
										paddingAngle: 2,
										cornerRadius: 0,
										startAngle: 0,
										endAngle: 360,
										cx: 120,
										cy: 105,
										// Enable labels
										arcLabel: (item) => {
											const total = storeTypeCount.reduce((sum, slice) => sum + slice.value, 0);
											const percent = ((item.value / total) * 100).toFixed(1);
											return `${percent}%`;
										},
										arcLabelMinAngle: 2,
										arcLabelRadius: "110%",
									},
								]}
								width={350}
								height={220}
							/>
						</Box>
						<Box pl={3}>
							<PieChart
								series={[
									{
										data: storeBrandCount,
										highlightScope: { fade: "global", highlight: "item" },
										faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
										innerRadius: 40,
										outerRadius: 90,
										paddingAngle: 2,
										cornerRadius: 0,
										startAngle: 0,
										endAngle: 360,
										cx: 135,
										cy: 105,
										label: {
											visible: true,
											type: "label", // This shows the "label" field from your data
											color: "blue",
											fontSize: 22,
										},
										// Enable labels
										arcLabel: (item) => {
											const total = storeBrandCount.reduce((sum, slice) => sum + slice.value, 0);
											const percent = ((item.value / total) * 100).toFixed(1);
											return `${percent}%`;
										},
										arcLabelMinAngle: 0,
										arcLabelRadius: "110%",
									},
								]}
								width={400}
								height={220}
							/>
						</Box>

						<Box pl={3}>
							<PieChart
								series={[
									{
										data: storeRegionCount,
										highlightScope: { fade: "global", highlight: "item" },
										faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
										innerRadius: 40,
										outerRadius: 90,
										paddingAngle: 2,
										cornerRadius: 0,
										startAngle: 0,
										endAngle: 360,
										cx: 125,
										cy: 105,
										label: {
											visible: true,
											type: "label", // This shows the "label" field from your data
											color: "blue",
											fontSize: 22,
										},
										// Enable labels
										arcLabel: (item) => {
											const total = storeRegionCount.reduce((sum, slice) => sum + slice.value, 0);
											const percent = ((item.value / total) * 100).toFixed(1);
											return `${percent}%`;
										},
										arcLabelMinAngle: 25,
										arcLabelRadius: "110%",
									},
								]}
								width={355}
								height={220}
							/>
						</Box>
					</Stack>
				</Box>
			</Card>

			<Card>
				<MapChart />
			</Card>
		</Box>
	);
}

export default Summary;
